import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../../shared/models/alert";
import { CreateApplicationUtilsConstants } from "./create-application-utils.constants";
export class CreateApplicationUtils {
    static duplicatePropertyErrorMessage = CreateApplicationUtilsConstants.DUPLICATE_MESSAGE;
    static propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null && value !== " " ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    static updatePropertyIds(selectedApplication, propertiesForm) {
        if (selectedApplication && selectedApplication.properties.length > 0) {
            const savedProperties = selectedApplication.properties?.sort((a, b) => (a?.value?.id?.localeCompare(b?.value?.id)));
            const propertyFormGroups = propertiesForm.get("properties").controls;
            propertyFormGroups.forEach((propertyFormGroup) => {
                const selectedPropertySgCode = this.propertyDataAlternateColumnName(propertyFormGroup.value, "SgCode", "sgCode");
                savedProperties.forEach((savedProperty) => {
                    if (savedProperty.sgCode === selectedPropertySgCode) {
                        const ownersControl = propertyFormGroup.get("owners");
                        propertyFormGroup.get("id").setValue(savedProperty.id);
                        if (ownersControl && ownersControl.value) {
                            propertyFormGroup.get("owners").setValue(savedProperty.owners);
                        }
                    }
                });
            });
        }
    }
    static checkIfPropertyIsADuplicate(sgCode, properties, appControllerService, requestStatusService) {
        let found = false;
        if (properties.length > 0) {
            properties.controls.forEach(item => {
                const check = item.get("sgCode").value;
                if (check === sgCode) {
                    found = true;
                    appControllerService.showMessage(this.duplicatePropertyErrorMessage, AlertType.Warning);
                    requestStatusService.removeBusySpinner("GetPropertyData");
                }
            });
        }
        return found;
    }
    static createNewPropertyFormGroup(propertyAttributes, sgCode, geometry) {
        return new FormGroup({
            id: new FormControl(0),
            erfNo: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "ErfNo", "erfno"), [Validators.required]),
            subdivision: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "PtnNum", "ptnnum"), [Validators.required]),
            allotment: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "Allotment", "allotment"), [Validators.required]),
            farmNo: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "FarmNo", "farmno"), [Validators.required]),
            sgCode: new FormControl(sgCode, [Validators.required]),
            address: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "Address", "address"), [Validators.required]),
            buildingUse: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "BuildingUse", "buildinguse")),
            erfSize: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "ErfSize", "erfsize"), [Validators.required]),
            buildingFloorArea: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "BuildingFloorArea", "buildingfloorarea"), [Validators.required]),
            titleDeed: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "TitleDeed", "titledeed"), [Validators.required]),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
            zones: new FormArray([], [Validators.required, Validators.min(1)]),
            owners: new FormControl(null, [Validators.required])
        });
    }
    static setTrueCentroidOnNewProperty(newPropertyFormGroup, trueCentroidResponse) {
        newPropertyFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
    }
    static handleTrueCentroidResponse(trueCentroidResponse, newPropertyFormGroup) {
        CreateApplicationUtils.setTrueCentroidOnNewProperty(newPropertyFormGroup, trueCentroidResponse);
    }
    static getUpdatedPropertyFormGroup(savedProperty, geom) {
        return new FormGroup({
            id: new FormControl(savedProperty.id),
            property: new FormControl(savedProperty),
            erfNo: new FormControl(savedProperty.erfNumber, [Validators.required]),
            subdivision: new FormControl(savedProperty.subdivision, [Validators.required]),
            allotment: new FormControl(savedProperty.allotment, [Validators.required]),
            farmNo: new FormControl(savedProperty.farmNumber, [Validators.required]),
            sgCode: new FormControl(savedProperty.sgCode, [Validators.required]),
            address: new FormControl(savedProperty.address, [Validators.required]),
            buildingUse: new FormControl(savedProperty.buildingUse),
            erfSize: new FormControl(savedProperty.erfSize, [Validators.required]),
            buildingFloorArea: new FormControl(savedProperty.buildingFloorArea, [Validators.required]),
            titleDeed: new FormControl(savedProperty.titleDeed, [Validators.required]),
            geometry: new FormControl(geom),
            centroid: new FormControl(null, [Validators.required]),
            zones: new FormArray([], [Validators.required, Validators.min(1)]),
            owners: new FormControl(savedProperty.owners, [Validators.required])
        });
    }
}
